import { parseAlgoliaHit as t } from "../../parseAlgoliaHit.js";
var e = {
  render: function render() {
    return this.$slots.default;
  }
};
export default {
  name: "AisHighlighter",
  props: {
    hit: {
      type: Object,
      required: !0
    },
    attribute: {
      type: String,
      required: !0
    },
    highlightedTagName: {
      type: String,
      default: "mark"
    },
    suit: {
      type: Function,
      required: !0
    },
    highlightProperty: {
      type: String,
      required: !0
    },
    preTag: {
      type: String,
      required: !0
    },
    postTag: {
      type: String,
      required: !0
    }
  },
  data: function data() {
    return {
      TextNode: e
    };
  },
  computed: {
    parsedHighlights: function parsedHighlights() {
      return t({
        attribute: this.attribute,
        hit: this.hit,
        highlightProperty: this.highlightProperty,
        preTag: this.preTag,
        postTag: this.postTag
      });
    }
  }
};